import React, {useState} from "react";
import ValidateMessages from "../../../../../../../../../core/models/static/texts/vallidate-messages";
import useIsMounted from "../../../../../../../../hooks/use-is-mounted";
import Api from "../../../../../../../../../core/services/api/api";
import {Col, Row} from "reactstrap";
import IconButton from "../../../../../../../base/button/icon_button";
import {ArrowBack} from "@mui/icons-material";
import Form from "../../../../../../../base/form";
import {MuiRFF, Yup} from '../../../../../../../form';
import {Divider} from "@mui/material";
import Button from "../../../../../../../base/button/button";
import DateUtils from "../../../../../../../../../core/services/date-utils";

const schema = Yup.object().shape({
    expiryDate: Yup.mixed()
        .nullable()
        .validDate(ValidateMessages.incorrect)
        .disablePastDate(ValidateMessages.minDate("today"), 'day')
        .minDate(() => DateUtils.serverToUTC(DateUtils.serverNow().startOf('day').add(1, 'day')), (params) => `Minimum date is ${DateUtils.UTCToLocal(params.min).format(DateUtils.dateFormat)}`)
        .required(ValidateMessages.required),
})

const AddPartSupportRequestLookupSectionRenewalExpirationDateSection = ({
                                                                            message,
                                                                            defineValues,
                                                                            lookupValues,
                                                                            submitInitialRequest,
                                                                            goBack,
                                                                            submittingRequest,
                                                                        }) => {
    const validate = MuiRFF.makeValidate(schema);
    const required = MuiRFF.makeRequired(schema);
    const [updating, setUpdating] = useState(false);
    const isMounted = useIsMounted();

    /**
     * Submits a new warranty expiration date for the selected serial number.
     * @param values {any} form values
     */
    const submitNewWarrantyExpirationDate = async (values) => {
        setUpdating(true);
        const forApi = {
            partNo: lookupValues.part?.partNumber,
            invoiceNo: lookupValues.invoiceNo,
            newDate: DateUtils.UTCToServer(values.expiryDate).endOf('day').format(DateUtils.withoutOffsetFormat),
            customerId: defineValues.customer?.id,
            reqTypeId: defineValues.type?.id,
        }
        // if serialized then only change the expiration date for the specific serial number
        if (lookupValues.isSerialized) {
            forApi['serialNo'] = lookupValues?.serialNumber;
            delete forApi.invoiceNo;
            delete forApi.partNo;
        }
        const response = await Api.SubmitNewExpirationDateForSerialNumber(forApi)
        if (!isMounted())
            return;
        setUpdating(false);
        if (response?.resultFlag) {
            submitInitialRequest();
        }
    }


    return (
        <>
            <Col xs={12} className={'row no-gutters align-items-center justify-content-start mb-4 px-3'}>
                <IconButton

                    onPressed={goBack}
                    color={'secondary'}
                >
                    <ArrowBack className={'icon normal'}/>
                </IconButton>
                <p className={'expiration-renewal-title'}>Expiration Renewal</p>
            </Col>
            <Form
                onSubmit={submitNewWarrantyExpirationDate}
                validate={validate}
                className='w-100'
                render={({submitting}) => {
                    const colClass = 'px-2 mb-4';
                    return (
                        <>
                            <Row
                                className='no-gutters align-items-end justify-content-start w-100 px-3 p-3'>
                                <p className={'expiration-renewal-description'}>
                                    {message ?? ''}
                                </p>
                                <Col xs={12} className={colClass}>
                                    <MuiRFF.DatePicker
                                        name={'expiryDate'}
                                        label={"New Expiration Date"}
                                        required={required.expiryDate}
                                        disablePast
                                    />
                                </Col>
                            </Row>
                            <div className='my-3 w-100'/>
                            <Divider className='divider'/>
                            <Row className='no-gutters footer justify-content-between align-items-start w-100'>
                                <Button
                                    disabled={submitting || updating}
                                    variant={'dialog'}
                                    color={'primary'}
                                    onClick={goBack}
                                    borderRadius={'0 8px 0 8px'}
                                >
                                    Back
                                </Button>
                                <Button
                                    disabled={updating || submittingRequest}
                                    variant={'dialog'}
                                    color={'primary'}
                                    type={'submit'}
                                    borderRadius={'8px 0 8px 0'}
                                >
                                    {
                                        submittingRequest
                                            ? "Submitting..."
                                            : updating
                                                ? 'Updating...'
                                                : 'Update'
                                    }
                                </Button>
                            </Row>
                        </>
                    );
                }}/>
        </>
    );
}

export default AddPartSupportRequestLookupSectionRenewalExpirationDateSection;
